(function() {
    'use strict';
    angular.module('irricrops')
        .directive('irriInclude', ["$controller", function($controller) {
          return {
            restrict: 'E',
            template:"<div ng-include='templateUrl'></div>",
            replace:false,
            scope: {
              locals: "=",
              controller   : "=",
              controllerAs : "=",
              templateUrl  : "="
            },
            link: function(scope, elem, attr) {
              scope.included = true;
              var locals = {
                $scope: scope,
              };
              angular.forEach(scope.locals, function(value, key) {
                locals[key] = value;
              });
              var l = $controller(scope.controller+' as '+scope.controllerAs, locals);
            }
          };
    }]);
})();
